export default () => Math.random().toString(36).slice(-6);
